var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5304_2516)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.836084 0.145835C0.642369 -0.0509614 0.331107 -0.0482396 0.140863 0.151914C-0.0493818 0.352068 -0.0465679 0.67386 0.147148 0.870657L7.30067 8.13794L0.418595 15.1295C0.224879 15.3263 0.222201 15.6479 0.412613 15.8479C0.603026 16.0479 0.914423 16.0505 1.10814 15.8537L8.00189 8.85032L14.8905 15.8485C15.0842 16.0453 15.3955 16.0426 15.5858 15.8424C15.776 15.6423 15.7732 15.3205 15.5795 15.1237L8.7031 8.13796L15.8515 0.875854C16.0452 0.679058 16.0479 0.357395 15.8575 0.1574C15.6671 -0.0425939 15.3557 -0.0451863 15.162 0.15161L8.00187 7.42559L0.836084 0.145835Z",
    fill: "#3C4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5304_2516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCloseIcon);
export default __webpack_public_path__ + "static/media/alert-close-icon.b2b16952d6f89b65c073451bd8e7e946.svg";
export { ForwardRef as ReactComponent };